if (!customElements.get('pulse-brand-wall')) {
  class PulseBrandWall extends HTMLElement {
    connectedCallback() {
      this._initAnimations();
      this._initPlayButton();
    }

    _initAnimations() {
      if (this.dataset.animate === 'false') return;

      const targets = this.querySelectorAll('[data-anim]');
      if (!targets.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            const delay = parseInt(el.dataset.animDelay || '0', 10);
            setTimeout(() => el.classList.add('pbw--visible'), delay);
            observer.unobserve(el);
          });
        },
        { threshold: 0.1 }
      );

      targets.forEach((el) => observer.observe(el));
    }

    _initPlayButton() {
      const playBtn = this.querySelector('.pbw__play');
      if (!playBtn) return;

      const isLightbox = this.dataset.lightbox === 'true';
      const dialog = this.querySelector('.pbw__lightbox');
      const inlineVideo = this.querySelector('.pbw__media-fill[data-inline-video]');
      const card = this.querySelector('.pbw__media-card');
      const lightboxVideo = dialog ? dialog.querySelector('.pbw__lightbox-video') : null;
      const closeBtn = dialog ? dialog.querySelector('.pbw__lightbox-close') : null;

      playBtn.addEventListener('click', () => {
        if (isLightbox && dialog) {
          dialog.showModal();
          if (lightboxVideo) {
            lightboxVideo.play();
          }
        } else if (inlineVideo) {
          if (inlineVideo.paused) {
            inlineVideo.play();
            card && card.classList.add('is-playing');
          } else {
            inlineVideo.pause();
            card && card.classList.remove('is-playing');
          }
        }
      });

      if (closeBtn && dialog) {
        closeBtn.addEventListener('click', () => {
          dialog.close();
          if (lightboxVideo) lightboxVideo.pause();
        });
      }

      if (dialog) {
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) {
            dialog.close();
            if (lightboxVideo) lightboxVideo.pause();
          }
        });

        dialog.addEventListener('close', () => {
          if (lightboxVideo) {
            lightboxVideo.pause();
            lightboxVideo.currentTime = 0;
          }
        });
      }
    }
  }

  customElements.define('pulse-brand-wall', PulseBrandWall);
}
